<template>
  <div ref="component" class="cx_style deng">
    <div class="cx_select verticallyCenter" :style="getSelectStyle">
      <div v-if="title.length" class="select_title">{{ title }}</div>
      <div class="flex1" style="position: relative">
        <span class="selected-icon" v-if="selectDirection" :class="selectDirection"></span>
        <el-select
          style="width: 100%"
          :popper-append-to-body="appendToBody"
          v-model="valueSync"
          v-on="$listeners"
          v-bind="$attrs"
        >
          <el-option
            v-for="(item, index) in selectOptions"
            :key="index"
            :data-value="selectValue ? (selectValue === 'item' ? item : item[selectValue]) : item.value"
            :label="selectLabel ? (selectLabel === 'item' ? item : item[selectLabel]) : item.label"
            :value="selectValue ? (selectValue === 'item' ? item : item[selectValue]) : item.value"
          >
            <el-tooltip
              v-if="showTooltip"
              class="item"
              effect="dark"
              :content="item[toolTipValue]"
              :placement="tooltipPosition"
            >
              <span style="float: left">{{ item.label.length > maxTextSize ? item.label.slice(0, maxTextSize) + "..." : item.label }}</span>
            </el-tooltip>
              <template  v-if="showIcon">
                <span style="float: left;line-height: inherit;margin-right: 8px"  :class="item.icon"></span>
                <span style="float: left">{{ item.label.length > maxTextSize ? item.label.slice(0, maxTextSize) + "..." : item.label }}</span>
              </template>
          </el-option>
        </el-select>
      </div>
    </div>
  </div>
</template>

<script>
import "../common.css"
import publicData from "../mixins/publicData.js"

export default {
  mixins: [publicData],
  name: "cxSelect",
  props: {
    selectOptions: {
      type: Array,
      required: true
    },
    showTooltip: {
      type: Boolean,
      default: false
    },
    showIcon:{
      type: Boolean,
      default: false
    },
    selectDirection:{
      type: String,
      default: ""
    },
    toolTipValue: {
      type: String,
      default: "label"
    },
    tooltipPosition: {
      type: String,
      default: "top"
    },
    title: {
      type: String,
      default: ""
    },
    titleSize: {
      type: String,
      default: "auto"
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    maxTextSize: {
      type: Number,
      default: 10
    },
    value: {
      required: true
    },
    selectLabel: {
      type: String,
      default: undefined,
      required: false
    },
    selectValue: {
      type: String,
      default: undefined,
      required: false
    }
  },
  computed: {
    getSelectStyle() {
      return {
        "--titleSize": this.titleSize
      }
    },
    valueSync: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit("update:value", val)
      }
    }
  },
  methods: {
    focus() {
      console.log(1, arguments)
    }
  }
}
</script>

<style scoped>
.cx_select {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.select_title {
  margin-right: 16px;
  width: var(--titleSize);
}
.selected-icon{
  position: absolute;
  left:11px;
  top:50%;
  transform: translateY(-50%);
  z-index: 1;
  pointer-events: none;
}
</style>
